import * as actionTypes from "./actionTypes";
import axios from "axios";
import jwt from "jsonwebtoken";

// import { Redirect } from 'react-router-dom';

export const authStart = () => {
  return {
    type: actionTypes.AUTH_START,
  };
};

export const emailValid = (email) => {
  return {
    type: actionTypes.EMAIL_VALID,
    email: email,
  };
};

export const emailInValid = () => {
  return {
    type: actionTypes.EMAIL_INVALID,
  };
};

export const authSuccess = (authData) => {
  return {
    type: actionTypes.AUTH_SUCCESS,
    authData: authData,
  };
};

export const passStart = () => {
  return {
    type: actionTypes.PASS_START,
  };
};

export const passWrong = (email) => {
  return {
    type: actionTypes.PASS_INVALID,
    email: email,
  };
};

export const authFail = (error) => {
  return {
    type: actionTypes.AUTH_FAIL,
    error: error,
  };
};

export const setAuthRedirectPath = (path) => {
  return {
    type: actionTypes.SET_AUTH_REDIRECT_PATH,
    path: path,
  };
};

export const logout = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("expireIn");
  localStorage.removeItem("user");
  localStorage.removeItem("company");
  localStorage.removeItem("comp");
  localStorage.removeItem("inst");
  return {
    type: actionTypes.AUTH_LOGOUT,
  };
};

// action jika token kadaluarsa
export const checkAuthTimeout = (expireTime) => {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(logout());
    }, expireTime.getTime() / 1000);
  };
};

export const auth = (email) => {
  const data = {
    email: email,
  };

  return (dispatch) => {
    dispatch(authStart());
    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/checkemail`, data)
      .then((result) => {
        if (result.data.message === "E-mail found") {
          dispatch(emailValid(result.data));
        } else {
          dispatch(emailInValid());
        }
      })
      .catch((err) => {
        dispatch(authFail(err));
      });
  };
};

export const authPassword = (email, password) => {
  const data = {
    email: email,
    password: password,
  };

  return (dispatch) => {
    dispatch(passStart());
    axios
      .post(`${process.env.REACT_APP_API_URL}/auth/login`, data)
      .then((result) => {
        if (result.data.code === 401) {
          dispatch(passWrong(email));
        } else {
          const expDate = new Date(new Date().getTime() + 1000 * 60 * 60 * 10); // 10 Jam dari backend node expressnya
          const setToken = localStorage.setItem("token", result.data.token);
          const companyId = localStorage.setItem(
            "company",
            JSON.stringify({
              branch: result.data.branchId,
              company: result.data.companyId,
            })
          );
          const setExpireTime = localStorage.setItem("expireIn", expDate);

          // Include flag_master from backend response
          const flagMaster = result.data.flag_master;

          Promise.all([setToken, setExpireTime, companyId]).then(() => {
            dispatch(
              authSuccess({
                ...result.data,
                flag_master: flagMaster
              })
            );
            dispatch(checkAuthTimeout(expDate));
          });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch(authFail(err));
      });
  };
};

export const authCheckState = () => {
  return (dispatch) => {
    const token = localStorage.getItem("token");
    const companyId = localStorage.getItem("company");
    const expireIn = localStorage.getItem("expireIn");

    if (!token || !companyId || !expireIn) {
      dispatch(logout());
      return;
    }

    const exptime = new Date(expireIn);
    const now = new Date();

    if (now.getTime() > exptime.getTime()) {
      dispatch(logout());
      return;
    }

    try {
      const decoded = jwt.verify(token, process.env.REACT_APP_TOKEN_KEY);
      const data = {
        data: {
          token,
          userId: decoded.userId,
          nameUser: decoded.nameUser,
          name_company: decoded.name_company,
          companyId: decoded.companyId,
          branchId: companyId,
          createdBy: `${decoded.nameUser} (${decoded.userId})`,
          updatedBy: `${decoded.nameUser} (${decoded.userId})`,
          flag_master: decoded.flag_master, // Sertakan flag_master
        },
      };
      dispatch(authSuccess(data));
    } catch (error) {
      console.error("JWT verification failed:", error);
      dispatch(logout());
    }
  };
};

// harus install redux-thunk
